<template>
    <div class="container">
        <div class="navbar-sec">
            <div class="nav-left">
                <ul>
                    <li v-if="siteSettings">
                        <router-link to="/" class="desktop-logo">
                            <img loading="lazy" :src="siteSettings?.aws_url + siteSettings?.storage_path.domain_image + siteSettings?.logo"
                                alt="" />
                        </router-link>
                        <router-link to="/" class="mobile-logo" aria-label="Home">
                        <img loading="lazy" :src="siteSettings?.aws_url + siteSettings?.storage_path.domain_image + siteSettings?.logo" alt="Site logo">
                    </router-link>

                    </li>
                    <li class="input-form">
                        <div class="search-bar">
                            <form autocomplete="off">
                                <input type="text" class="form-control" :placeholder="$t('search-events','Search Events')" 
                                v-model="searchText" @input="searchDebounce()" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"  />
                            </form>
                            <span class="search-icon">
                                <i v-if="searchText?.length == 0" class="fa-solid fa-magnifying-glass"></i>
                                <i @click="searchText = ''" v-if="searchText?.length > 0" class="fa-solid fa-times text-light"></i>
                            </span>
                        </div>
                        <div class="autosearch-data" v-if="searchText?.length > 2 && searchResult != null && (searchResult?.length != 0)">
                            <template v-for="(search, sItem) in searchResult" :key="sItem">
                                <a @click="openSportEventDetailPage(search)" class="autosearch-item"> 
                                    {{ search?.event_name ?search?.event_name : search?.game_name }}
                                    <span v-if="search?.game_name">- {{ search?.provider }}</span>
                                </a>
                            </template>
                        </div>
                        <div v-if="searchText?.length > 2 && (searchResult?.length == 0)" class="autosearch-data">
                            <div class="autosearch-noData">{{$t('no-data-found', 'No data found')}}</div>
                        </div>
                    </li>

                    <li class="rules-box">
                        <div class="d-w-box">
                            <ul v-if="$auth?.status && siteSettings && siteSettings?.business_type == 2">
                                <li v-if="$auth?.status">
                                    <router-link :to="{ name: 'wallet-withdraw' }">
                                        <img loading="lazy" src="@/assets/images/withdrawal-icon.svg" style="height: 15px;" alt="withdrawal-icon">
                                        <span>{{$t('withdrawal','Withdrawal')}}</span>
                                    </router-link>
                                </li>
                                <li v-if="$auth?.status" class="cnm-deposit-wdr-btn">
                                    <router-link :to="{ name: 'wallet-deposit' }" class="deposit-btn">
                                        <img loading="lazy" src="@/assets/images/deposit-icon.webp" alt="deposit-icon">
                                        <span>{{$t('deposit', 'Deposit')}}</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>

                </ul>
            </div>
            <div class="nav-right header-nav-rgt">
                <ul v-if="!$auth?.status" class="login-sign-btn-m">
                    <li v-if="siteSettings && siteSettings?.business_type == 2">
                        <button href="#register-btn" data-bs-toggle="modal" class="cmn-btn12">{{$t('register', 'Register')}}</button>
                    </li>
                    <li>
                        <button href="#login-btn" data-bs-toggle="modal" class="cmn-btn12 login-btn-header">{{$t('log-in', 'Login')}}</button>
                    </li>
                </ul>

                <ul v-if="$auth?.status && $auth?.user" class="exposer-user-h">
                    <li>
                        <a class="bal-exp">
                            <span> {{$t('bal','BAL')}}  </span>
                            <b>{{ $auth?.user?.balance }}</b>
                        </a>
                    </li>
                    <li>
                        <router-link to="/market-analysis" class="bal-exp exp-bal-show">
                            <span> {{$t('exp','EXP')}} </span>
                            <b>{{ $auth?.user?.exposure!=null ? -parseInt($auth?.user?.exposure) : 0 }}</b>
                        </router-link>
                    </li>
                    <li>
                        <div class="dropdown open-menu-btn">
                            <button v-if="$auth?.user" class="btn btn-secondary" type="button"
                                id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                <span class="text-capitalize">{{ $auth?.user?.userid }}</span>
                                <img loading="lazy" src="@/assets/images/user-i.svg" alt="">
                                <!-- <i class="fa fa-user"></i> -->
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                <li class="mobile-num">
                                    <span class="text-capitalize">Hi, {{ $auth?.user?.userid }}</span>
                                    <img class="copy_profile_txt" loading="lazy" @click.prevent.stop="copyUserId()" src="@/assets/images/copy_icon.svg" alt="" srcset="">
                                    <div class="copt_text_hover" v-if="copied">
                                        {{$t('copied','UserId Copied')}}!
                                    </div>
                                </li>
                                <div class="right-side-menu-scrollbar">                              
                                    <div class="setting-user-checkbox" onclick="event.stopPropagation();">
                                        <div class="user-details-r">
                                            <label class="form-check-label" for="flexSwitchCheckDefault" >{{$t('one-click-bet', 'One Click Bet')}}</label>
                                            <div class="form-check form-switch">
                                                <input class="form-check-input" id="flexSwitchCheckDefault" type="checkbox" v-model="clickBetCheck"
                                                    @change="betCheckChangeFunc()">
                                            </div>
                                            <div class="one-bet-click-value" >
                                                <label v-if="clickBetCheck && getClickBetSelectedValue()"
                                                @click="$refs.open_click_bet_value.click()">{{ getClickBetSelectedValue() }}</label>
                                            </div>
                                        </div>
                                        <a style="display: none;" ref="open_click_bet_value" data-bs-toggle="modal"
                                            data-bs-target="#clickBetValues"></a>
                                    </div>
                                    <li class="menu-rgt-icons">
                                        <div class="balance-row">
                                            <div class="balance-text-left">Wallet Amount <small>(Inclusive bonus)</small></div>
                                            <div class="balance-price">{{($auth.user?.balance || 0 - (+lockedEarnedData?.earnBonus || 0) + parseInt($auth.user?.expl || 0)).toFixed(2)}}</div>
                                        </div>
                                        <div class="balance-row">
                                            <div class="balance-text-left">Net Exposure</div>
                                            <div class="balance-price">{{parseInt((-1) * ($auth?.user?.exposure || 0)).toFixed(2)}}</div>
                                        </div>
                                    </li>
                                    <li class="bonus-information-bx" v-if="siteSettings && siteSettings?.business_type == 2">
                                        <div class="credits-chackn-box" @click="getRules()" data-bs-toggle="modal" data-bs-target="#informationModal">
                                            <div class="menu-details-heading" >
                                                <h4>{{$t('bonus-information', 'Bonus Information')}}</h4> 
                                                <span class="information-icon"  >
                                                        <a href="#"><img loading="lazy" src="@/assets/images/info-icon.svg" alt="info-icon"></a>
                                                </span>
                                                
                                            </div>
                                        </div>
                                        
                                        <div class="bonus-sec" v-if="lockedEarnedData">
                                            <div class="credits-chackn-box"  onclick="event.stopPropagation();">
                                                <div class="menu-details-heading">
                                                    <h4>{{$t('earn-bonus', 'Earned Bonus')}}</h4> 
                                                    <span class="ml-2"> {{ lockedEarnedData.earnBonus }}</span>
                                                </div>
                                            </div>
                                            <div class="credits-chackn-box">
                                                <div class="menu-details-heading credits-bonus-list" @click="openBonusLogs()">
                                                    <div class="locked-bonus-dflex">
                                                        <button class="btn locked-bonus-btn">{{$t('locked-bonus', 'Locked Bonus')}}</button>
                                                    </div>
                                                    <span class="ml-2"> {{ lockedEarnedData.lockedBonus }}</span>
                                                </div>
                                            </div>
                                          
                                            <div class="credits-chackn-box" onclick="event.stopPropagation();">
                                                <div class="menu-details-heading">
                                                    <h4 >{{$t('welcome-bonus', 'Welcome Bonus')}} </h4>
                                                    <span>{{ lockedEarnedData.welcomeBonus }}</span>
                                                </div>
                                            </div>
                                            <div class="credits-chackn-box border-0" onclick="event.stopPropagation();">
                                                <div class="menu-details-heading">
                                                    <h4>{{$t('play-with-bonus', 'Play with Bonus')}}</h4>
                                                </div>
                                                <div class="menu-heading-con">
                                                    <div class="form-check form-switch m-0 p-0">
                                                        <input class="form-check-input" type="checkbox"
                                                            id="settingCheckDefaults" v-model="getWalletType" @change="updateWalletType">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>

                                    <li class="menu-rgt-icons" v-if="siteSettings?.business_type == 2">
                                        <router-link :to="{ name: 'refer-earn' }" class="dropdown-item">
                                            <i class="bi bi-people"></i>
                                            <span class="menu-rgt-text">{{$t('refer-and-earn','Refer Earn')}}</span>
                                        </router-link>
                                    </li>

                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'profile', params: { type: 'PROFILE_OVERVIEW' } }"
                                            class="dropdown-item">
                                            <i class="bi bi-person"></i>
                                            <span class="menu-rgt-text">{{$t('my-profile','My Profile')}}</span>
                                        </router-link>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <a @click="openBetsPage('open')" class="dropdown-item">
                                            <!-- <img loading="lazy" src="@/assets/images/line-chart.webp" alt=""> -->
                                            <i class="bi bi-bar-chart"></i>
                                            <span class="menu-rgt-text">{{$t('unsettled-bets','Unsettled Bets')}}</span>
                                        </a>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <a @click="openBetsPage('settled')" class="dropdown-item">
                                            <!-- <img loading="lazy" src="@/assets/images/line-chart.webp" alt=""> -->
                                            <i class="bi bi-file-text"></i>
                                            <span class="menu-rgt-text">{{$t('bet-history','Bet History')}}</span>
                                        </a>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'profit-loss' }" class="dropdown-item"
                                            href="profit-loss.html">
                                            <!-- <img loading="lazy" src="@/assets/images/line-chart.webp" alt=""> -->
                                            <i class="bi bi-bar-chart-line"></i>
                                            <span class="menu-rgt-text">{{$t('profit-loss','Profit & Loss')}}</span>
                                        </router-link>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'statements' }" class="dropdown-item" href="statement.html">
                                            <!-- <img loading="lazy" src="@/assets/images/file.webp" alt=""> -->
                                            <i class="bi bi-bar-chart-steps"></i>
                                            <span class="menu-rgt-text">{{$t('account-statement','Account statement')}}</span>
                                        </router-link>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'profile', params: { type: 'STAKE_SETTING' } }"
                                            class="dropdown-item" href="stake.html">
                                            <!-- <img loading="lazy" src="@/assets/images/bullseye.webp" alt=""> -->
                                            <i class="bi bi-bullseye"></i>
                                            <span class="menu-rgt-text">{{$t('stake-settings','Stake Settings')}}</span>
                                        </router-link>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'Notifications'}"
                                            class="dropdown-item">
                                            <img loading="lazy" src="@/assets/images/notification_icon.svg" alt="">
                                            <!-- <i class="bi bi-bullseye"></i> -->
                                            <span class="menu-rgt-text">{{$t('notification','Notifications')}}</span>
                                        </router-link>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <a data-bs-toggle="modal" data-bs-target="#language_selection_pop_up">
                                            <i class="bi bi-globe"></i>
                                            <span class="menu-rgt-text">{{$t('language','Language')}}</span>
                                        </a>
                                    </li>
                                    <li class="menu-rgt-icons">
                                        <router-link :to="{ name: 'profile', params: { type: 'CHANGE_PASSWORD' } }"
                                            class="dropdown-item" href="change-password.html">
                                            <!-- <img loading="lazy" src="@/assets/images/padlock.webp" alt=""> -->
                                            <i class="bi bi-lock"></i>
                                            <span class="menu-rgt-text">{{$t('change-password','Change Password')}}</span>
                                        </router-link>
                                    </li>
                                </div>
                                <li @click="logoutBtnClick()" class="menu-rgt-icons">
                                        <a class="dropdown-item signout-btn">
                                            <!-- <img loading="lazy" src="@/assets/images/logout.webp" alt=""> -->
                                            <i class="bi bi-box-arrow-right"></i>
                                            <span class="menu-rgt-text">{{$t('sign-out','Sign Out')}}</span>
                                        </a>
                                    </li>
                            </ul>
                        </div>
                    </li>
                </ul>

            </div>
        </div>

    </div>
    <div v-if="$auth?.status && siteSettings && siteSettings?.business_type == 2" class="deposit-and-wdrl--m-sec">
        <div class="deposit-m">
            <router-link :to="{ name: 'wallet-deposit' }">
                <img loading="lazy" src="@/assets/images/deposit-icon.svg" alt="deposit-icon">
                <span>{{$t('deposit','Deposit')}}</span>
            </router-link>
        </div>
        <div class="withdraw-m">
            <router-link :to="{ name: 'wallet-withdraw' }">
                <img loading="lazy" src="@/assets/images/withdrawal-icon.svg" alt="withdrawal-icon">
                <span>{{$t('withdrawal','Withdrawal')}}</span>
            </router-link>
        </div>
    </div>

    <NavBar />
    <BonusModal :siteRuleData="siteRuleData"/>
    <ClickBetModal @close-modal="closeClickBetModal" />
    <LockedBonus v-if="showBonusLogs" @closeBonusLogs="closeBonusLogs()" />
</template>

<script>

import { defineAsyncComponent } from 'vue';
import { mapGetters } from 'vuex';
import { checkForLockedMatches, checkEventManageforSports, CheckEventMangeForCasinoInSearch } from '@/shared/services/eventLocks.js';
import loadCasinoGame from '@/shared/services/casinoGamesHandler';
export default {
    name: 'Header',
    components: {
        BonusModal: defineAsyncComponent(() =>
            import('@/shared/components/header/BonusInfoModal.vue')
        ),
        ClickBetModal: defineAsyncComponent(() =>
            import('@/shared/components/modal/ClickBetModal.vue')
        ),
        NavBar: defineAsyncComponent(() =>
            import('./NavBar.vue')
        ),
        LockedBonus: defineAsyncComponent(() =>
            import('@/shared/components/header/LockedBonus.vue')
        )
    },
    data(){
        return{
            clickBetCheck: this.$store?.getters?.isClickBetOn ? this.$store?.getters?.isClickBetOn : false,
            getWalletType:false,
            lockedEarnedData: null,
            showBonusLogs: false,
            siteRuleData: null,
            searchText: '',
            searchResult: null,
            rulesModal : false,
            copied: false
        }
    },
    mounted() {
        if (this.$store.getters.clickBetActive) {
            this.clickBetCheck = true
        }
        if(this.$auth?.status && this.siteSettings?.business_type == 2) {
            this.getLockedEarnedBonus();
            this.getWalletType = this.$auth?.user?.activeWallet == 'WB';
        } 
    },
    computed: {
        ...mapGetters([
            'siteSettings', 'getBalExpDisplay', 'getRecommendedMatch','stateUser'
        ])
    },
    methods: {
        closeClickBetModal(clickBetCheckValue) {
            this.clickBetCheck= clickBetCheckValue
        },
        copyUserId(){
            var input = document.createElement("textarea");
            input.value = this.$auth?.user?.userid;
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body?.removeChild(input);
            this.copied = true;
                // Reset copied text after 2 seconds
            setTimeout(() => {
                this.copied = false;
            }, 2000);
            
        },
        loadGame(game) {
            if(!this.$auth.status) {
                this.$helper.showLogin();
                return;
            }
            loadCasinoGame.loadGame(game, this.$auth.user);
        },
        CheckEventMangeForCasinoInSearch,
        updateWalletType() {
            this.$apiCall('post','UPDATE_WALLET_TYPE', {}).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            let user = this.$auth?.user;
                            user.activeWallet = response.data.data.active_wallet;
                            this.$store.dispatch('setUser', user);
                            this.$successToast('Successfully changed');
                            setTimeout(() => {
                                this.$emit('updateAuthToken', true);
                            },2000)
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.getWalletType = !this.getWalletType;
                    this.$errorToast(error[0]);
                }
            });
        },
        openBetsPage(type){
            this.$router.push('/bets/'+type);
        },
        openSportEventDetailPage(match) {
            this.searchResult = null;
            this.searchText = "";
            if(match?.event_id){
                this.$router.push({
                    name: 'sports-event-detail',
                    params: { event_id: match.event_id }
                });
            }
            else
                this.loadGame(match);
        },
        openBonusLogs() {
            this.showBonusLogs = true;
            
        },
        closeBonusLogs() {
            setTimeout(() => {
                this.showBonusLogs = false;
            }, 400)
        },
        getRules() {
            this.loading = true;
            if(this.siteRuleData) {
                return;
            }
            this.$apiCall('get','GET_SITE_RULES').then(response => {
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            let ruleResp = response.data.data;
                            this.siteRuleData = {}
                            ruleResp.forEach(item => {
                                this.siteRuleData[item.type] = item.content;
                            })
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        getLockedEarnedBonus() {
            this.$apiCall('get', 'GET_LOCKED_EARNED_BONUS', null, 'bonus').then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0]);
                        }
                        else {
                            this.lockedEarnedData = response.data.data;
                            this.lockedEarnedData.earnBonus = this.$auth.user.earnBonus;
                            this.$store.dispatch('setUserBonus', this.lockedEarnedData);
                            
                        }
                    }
                }
            }).catch(error => {
                this.$store.dispatch('setGlobalLoader', false);
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        betCheckChangeFunc() {
            if (this.clickBetCheck) {
                this.$refs.open_click_bet_value.click();
            }
            else {
                let valueInputs = this.$store.getters.clickBetValue;
                valueInputs.forEach(item => {
                    item.isSelected = false
                })
                this.$store.dispatch('setClickBetValue', valueInputs);
            }
        },
        getClickBetSelectedValue() {
            let inputValues = this.getClickBetValue();
            if (inputValues)
                return inputValues.filter(item => item.isSelected)[0]?.value;
        },
        getClickBetValue() {
            return this.$store.getters.clickBetValue ? [...this.$store.getters.clickBetValue] : null;
        },
        logoutBtnClick() {
            this.logoutServiceCall();
        },
        onChange(event) {
            let search = event.target.value;
            this.$store.dispatch('setSearchText', search);
            if(this.$route.name === 'Home')
                this.callHomeFunction();
        },
        callHomeFunction() {
            const homeComponent = this.$router.getRoutes().find(route => route.name === 'Home');
            if (homeComponent) {
                const instance = homeComponent.instances.default;
                if (instance && typeof instance.searchCasinoMatches === 'function') {
                    instance.searchCasinoMatches();
                }
            }
        },
        getSearchText() {
            return this.$store?.getters?.searchText;
        },
        logoutServiceCall() {
            this.$apiCall('get', 'LOGOUT_API').then(response => {
                this.loading = false;
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0) {
                            this.$errorToast(response.data.debug[0])
                        }
                        else {
                            this.$successToast(response?.data?.message);
                            localStorage.removeItem('is_offer');
                            localStorage.removeItem('isDemo');
                            localStorage.removeItem('fav_sports_list');
                            // remove all cookie
                            this.$cookies.keys().forEach(cookie => this.$cookies.remove(cookie))
                            this.$store.dispatch('resetAllState');
                            this.$router.push({ name: 'Home' }).then(() => {
                                window.location.reload();
                            });
                        }
                    }
                }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    this.$errorToast(error[0]);
                }
            });
        },
        searchDebounce() {
            if(this.searchText == '' && this.searchResult) {
                this.searchResult = null;
                return;
            }
            clearTimeout(this.debounceTime);
            this.debounceTime = setTimeout(() => {
                this.getSearch();
            }, 800)
        },
        getSearch() {
            try {
                this.searchResult = null;
                let data = {
                    "search": this.searchText
                };
                this.$apiCall('post', 'SEARCH', data).then(response => {
                    if (response && response.status && response.status == 200) {
                        let res = response.data.data ?? null;
                        let matches = this.SportsEventMange([...res?.matches])
                        this.searchResult = [...this.CheckEventMangeForCasinoInSearch(res?.casino), ...matches];
                    } else {
                        throw 'Please Refresh the page!!'
                    }
                }).catch(error => {
                    if (error) {
                        this.$errorToast(error[0]);
                    }
                });
            } catch (error) {
                console.log(error);
            }   
        },
        SportsEventMange(data){
            let resData = data ?? [];
            let matchesList = [];
            for(let i=0;i<resData.length;i++){
                let lockedMatchIds = [];
                let lockedLeagueIds = [];
                if(this.$auth.status && this.eventManage) {
                    lockedMatchIds = this.eventManage.find(item => item.type == 'match');
                    lockedLeagueIds = this.eventManage.find(item => item.type == 'league');

                    lockedMatchIds = lockedMatchIds && lockedMatchIds.type_id !== null ? lockedMatchIds.type_id.split(',') : [];
                    lockedLeagueIds = lockedLeagueIds && lockedLeagueIds.type_id !== null ? lockedLeagueIds.type_id.split(',') : []
                }
                if(checkEventManageforSports(resData[i].sport_id) && checkForLockedMatches(resData[i].matchId, resData[i].league_id, lockedMatchIds, lockedLeagueIds)) {
                    matchesList.push(resData[i]);
                }
            }
            return matchesList
        },
        updateSearch() {
            setTimeout(() => {
                this.searchResult = null;
                this.searchText = '';
            }, 200)
        }
       
    }
}
</script>